import { render, staticRenderFns } from "./MyPageAlert.vue?vue&type=template&id=5ac9e4ef&scoped=true&"
import script from "./MyPageAlert.vue?vue&type=script&lang=js&"
export * from "./MyPageAlert.vue?vue&type=script&lang=js&"
import style0 from "./MyPageAlert.vue?vue&type=style&index=0&id=5ac9e4ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac9e4ef",
  null
  
)

export default component.exports